export const VARIABLE = {
  // driveURL: 'https://drive.google.com/uc?export=view&id='
  driveURL: 'https://drive.google.com/thumbnail?id='
}